import { render } from "./yearSelector.vue?vue&type=template&id=5923f356&scoped=true"
import script from "./yearSelector.vue?vue&type=script&lang=js"
export * from "./yearSelector.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5923f356"]])

export default __exports__